import { TextField } from "./MyCustomFile"
export const MySearch = ({ name, label, value, onChange }) => {
    return (
        <TextField
            fullWidth
            variant="outlined"
            margin="dense"
            size="small"
            name={name}
            label={label}
            value={value || ''}
            onChange={onChange}
        />
    );
}